import type { VariantProps } from 'class-variance-authority';

import { cva } from 'class-variance-authority';

export { default as CarouselGenericAction } from './GenericAction.vue';

export const carouselButtonStyles = cva('flex items-center justify-center', {
	variants: {
		variant: {
			default: 'text-white hover:text-gray-400',
			dark: 'text-primary hover:text-primary/40',
			button:
				'border-2 border-gray-800 bg-gray-800 p-2 text-white hover:bg-gray-600'
		},
		padding: {
			none: '',
			small: 'px-2',
			medium: 'px-4',
			large: 'px-6'
		},
		border: {
			none: '',
			thin: 'border border-gray-500',
			thick: 'border-2 border-gray-700'
		},
		background: {
			transparent: 'bg-transparent',
			solid: 'bg-blue-500 hover:bg-blue-700',
			outlined:
				'border border-blue-500 bg-white text-blue-500 hover:bg-blue-500 hover:text-white'
		}
	},
	defaultVariants: {
		variant: 'default',
		padding: 'none',
		border: 'none',
		background: 'transparent'
	}
});

export type CarouselGenericActionVariants = VariantProps<
	typeof carouselButtonStyles
>;
